import { useNavigate } from "react-router-dom";
import { Heart, Trash2, ShoppingCart } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { formatINR } from "@/constants/branding";
import { Button } from "@/components/ui/button";

export default function WishlistPage() {
  const navigate = useNavigate();
  const { wishlist, toggleWishlist, addToCart } = useStore();

  if (!wishlist.length)
    return (
      <div className="shell py-10 sm:py-16">
        <div className="surface max-w-md mx-auto text-center py-14 px-6" data-testid="wishlist-empty">
          <div className="h-16 w-16 mx-auto mb-5 rounded-full bg-primary/10 flex items-center justify-center">
            <Heart className="h-8 w-8 text-primary" />
          </div>
          <h1 className="font-display text-2xl font-bold text-deep">Your wishlist is empty</h1>
          <p className="text-muted-foreground mt-2 mb-6">Save your favourite products to buy them later.</p>
          <Button className="rounded-xl h-11 px-7 font-bold" onClick={() => navigate("/products")} data-testid="wishlist-shop">Explore Products</Button>
        </div>
      </div>
    );

  return (
    <div className="shell py-5 sm:py-7 animate-fade-up">
      <h1 className="font-display text-3xl font-bold text-deep mb-5">My Wishlist <span className="text-muted-foreground text-xl font-semibold">({wishlist.length})</span></h1>
      <div className="grid gap-4">
        {wishlist.map((p) => (
          <div key={p.id} className="surface flex gap-4 p-4 sm:p-5 items-center" data-testid={`wishlist-item-${p.id}`}>
            <div className="h-20 w-20 sm:h-24 sm:w-24 shrink-0 rounded-xl bg-secondary overflow-hidden cursor-pointer" onClick={() => navigate(`/products/${p.id}`)}>
              <img src={(p.images || [])[0]} alt={p.name} className="h-full w-full object-contain p-1.5 mix-blend-multiply" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold line-clamp-2 cursor-pointer hover:text-primary transition-colors" onClick={() => navigate(`/products/${p.id}`)}>{p.name}</h3>
              <p className="text-xs uppercase tracking-wider text-muted-foreground mt-0.5">{p.category}</p>
              <p className="text-lg font-extrabold text-deep mt-1">{formatINR(p.price)}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 shrink-0">
              <Button size="sm" className="gap-1.5 rounded-xl font-bold" disabled={p.stock <= 0} onClick={() => addToCart(p.id, 1)} data-testid={`wishlist-add-cart-${p.id}`}>
                <ShoppingCart className="h-4 w-4" /> Add to Cart
              </Button>
              <Button size="sm" variant="outline" className="rounded-xl" onClick={() => toggleWishlist(p.id)} data-testid={`wishlist-remove-${p.id}`} aria-label="Remove from wishlist">
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
